// Login.jsx
import React, { useState } from 'react';
import axios from '../services/api';
import { useNavigate, Link } from 'react-router-dom';
import './Login.css';
import { getUserFromToken } from '../utils/auth'; // ✅ import this

export default function Login() {
  const [form, setForm] = useState({ email: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post('/auth/login', form);
      const { token } = res.data;

      if (token) {
        localStorage.setItem('token', token);
        alert('Login successful!');

        const user = getUserFromToken(); // ✅ decode token after saving
        console.log("🔐 Logged in user:", user);

        if (user.role === 'ADMIN') {
          navigate('/admin-panel');
        } else {
          navigate('/group-fare');
        }
      } else {
        alert('Login failed. No token received.');
      }
    } catch (err) {
      console.error(err);
      alert('Login failed');
    }
  };

  return (
    <div className="auth-container">
      <form className="auth-form" onSubmit={handleSubmit}>
        <div className="welcome-box">
          <h1 className="welcome-title">Get set. Go mighty.</h1>
        </div>

        <h2>Login</h2>
        <input
          name="email"
          type="email"
          placeholder="Email"
          required
          value={form.email}
          onChange={(e) => setForm({ ...form, email: e.target.value })}
        />
        <div className="password-field">
          <input
            name="password"
            type={showPassword ? 'text' : 'password'}
            placeholder="Password"
            required
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
          />
          <span onClick={() => setShowPassword(!showPassword)}>
            {showPassword ? (
              <i className="fas fa-eye-slash"></i>
            ) : (
              <i className="fas fa-eye"></i>
            )}
          </span>
        </div>
        <button type="submit">Login</button>
        <p>
          Don't have an account? <Link to="/signup">Sign Up</Link>
        </p>
      </form>
    </div>
  );
}
